import { useEffect, useState } from 'react';
import type { AuthUser, Membership } from '@buildmate/core';
import { usePorts } from './ports-context.tsx';

export interface AuthState {
  readonly user: AuthUser | null;
  readonly memberships: readonly Membership[];
  readonly loading: boolean;
}

/** Current user plus their company memberships, kept in sync with the port. */
export function useAuth(): AuthState {
  const ports = usePorts();
  const [state, setState] = useState<AuthState>({
    user: null,
    memberships: [],
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    const stop = ports.auth.onAuthStateChanged((user) => {
      if (!user) {
        if (!cancelled) setState({ user: null, memberships: [], loading: false });
        return;
      }
      void ports.auth.listMemberships().then((memberships) => {
        if (!cancelled) setState({ user, memberships, loading: false });
      });
    });
    return () => {
      cancelled = true;
      stop();
    };
  }, [ports]);

  return state;
}
